import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidElement, useContext } from 'react';
import { useLocalizeMessage, Spinner, LocaleContext, Table, formatStudyString } from 'libs.nucleus';
import { SectionCard } from 'libs.react';
import ActivityResponseTitle from './activity_response_title.component';
import StepResponseValue from './step_response_value.component';
import { getStepQuestion } from './visit_activity_responses.utils';
import { stepResponseTypes } from '../../constants/step_response_type.constants';
import { applyVariablesToStepResponse } from '../../helpers/step_response_variable.helpers';
export const VisitActivityResponses = ({ visitActivityResponses, isLoading }) => {
    const translate = useLocalizeMessage();
    const currentLocale = useContext(LocaleContext);
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    const columns = [
        {
            header: translate('generic.question'),
            accessorKey: 'question',
            cell: (context) => (_jsx("div", { className: 'text-sm text-gray-500', dangerouslySetInnerHTML: { __html: context.getValue() } })),
        },
        {
            header: translate('generic.responses', { count: 1 }),
            accessorKey: 'response',
            cell: (context) => {
                const value = context.getValue();
                return _jsx("div", { className: 'text-sm text-gray-900', children: isValidElement(value) ? value : String(value || '') });
            },
        },
    ];
    const activitiesWithResponses = visitActivityResponses.map((response) => {
        const metaVariables = response?.c_metadata || {};
        let detailsItems = (response?.c_step_responses?.data || [])
            .filter((stepResponse) => {
            return stepResponse.type !== stepResponseTypes.cCompletion.objectType && !stepResponse.c_step.c_disabled;
        })
            .sort((x, y) => x.c_step.c_order - y.c_step.c_order)
            .flatMap((stepResponse) => {
            const processedStepResponse = applyVariablesToStepResponse(stepResponse, metaVariables.variables);
            return [
                {
                    id: response._id,
                    question: formatStudyString(getStepQuestion(processedStepResponse.c_step), currentLocale),
                    response: _jsx(StepResponseValue, { stepResponse: processedStepResponse, variables: metaVariables.variables }),
                },
            ];
        });
        if (detailsItems.length === 0) {
            detailsItems = [
                {
                    id: response._id,
                    question: translate('info.visit_activity_responses.empty'),
                    response: translate('info.visit_activity_responses.none_recorded'),
                },
            ];
        }
        return {
            id: response.c_task?._id,
            title: _jsx(ActivityResponseTitle, { response: response, compactTitle: true }),
            content: (_jsx(Table, { data: detailsItems, columns: columns, isLoading: false, labelNoResults: translate('info.participant_responses.filter_empty'), hasPagination: false })),
        };
    });
    if (activitiesWithResponses.length === 0) {
        return (_jsx(SectionCard, { children: _jsx("section", { className: 'flex flex-col items-center justify-center p-10 m-10', children: _jsx("p", { className: 'text-sm text-secondary', children: translate('info.visit_activity_responses.none_for_visit') }) }) }));
    }
    return (_jsx("div", { className: 'flex flex-col gap-6', children: activitiesWithResponses.map((section) => (_jsxs("div", { children: [section.title, _jsx("div", { className: 'mt-[24px]', children: section.content })] }, section.id))) }));
};
